import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserContextService } from './user-context.service';
import { WorkspaceFeatureKey } from './workspace-feature.keys';

export interface WorkspaceFeatureFlagGuardData {
  featureKey: WorkspaceFeatureKey;
}

@Injectable({ providedIn: 'root' })
export class WorkspaceFeatureFlagGuard {
  constructor(
    private readonly userContextService: UserContextService,
    private readonly router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const data = route.data as WorkspaceFeatureFlagGuardData;
    const featureKey = data?.featureKey;

    if (!featureKey) {
      return true;
    }

    return this.userContextService.selectedWorkspace$.pipe(
      map((selectedWorkspace) => {
        if (!selectedWorkspace) {
          return this.router.createUrlTree(['workspace', 'selection'], {
            queryParams: { returnUrl: state.url },
          });
        }

        const isEnabled = selectedWorkspace[featureKey];
        if (!isEnabled) {
          return this.router.createUrlTree(['workspace']);
        }

        return true;
      })
    );
  }
}
